// extracted by mini-css-extract-plugin
var _1 = "cognito-login-form-module--alert--36191";
var _2 = "cognito-login-form-module--btn--0a278";
var _3 = "cognito-login-form-module--btnFilledFull--e5ecf";
var _4 = "cognito-login-form-module--btnFull--314df";
var _5 = "cognito-login-form-module--btnGap--84969";
var _6 = "cognito-login-form-module--btnLabelStrong--c8405";
var _7 = "cognito-login-form-module--btnOutlined--90421";
var _8 = "cognito-login-form-module--btnText--a3336";
var _9 = "cognito-login-form-module--center--fee04";
var _a = "cognito-login-form-module--centerRow--51bd6";
var _b = "cognito-login-form-module--emailForm--8b4e7";
var _c = "cognito-login-form-module--logo--77988";
var _d = "cognito-login-form-module--muted--93f7a";
var _e = "cognito-login-form-module--orDivider--e6991";
var _f = "cognito-login-form-module--panel--37b9e";
var _10 = "cognito-login-form-module--root--9bc5d";
var _11 = "cognito-login-form-module--social--81c04";
export { _1 as "alert", _2 as "btn", _3 as "btnFilledFull", _4 as "btnFull", _5 as "btnGap", _6 as "btnLabelStrong", _7 as "btnOutlined", _8 as "btnText", _9 as "center", _a as "centerRow", _b as "emailForm", _c as "logo", _d as "muted", _e as "orDivider", _f as "panel", _10 as "root", _11 as "social" }
